import { Component, OnInit } from '@angular/core';
import { BetInfoService } from 'app/providers/bet-info/bet-info.service';
import { ApiService } from 'app/providers/api/api.service';
import { GameConfig } from 'app/common/gameConfig';

@Component({
  selector: 'app-pcdd-panel',
  templateUrl: './pcdd-panel.component.html',
  styleUrls: ['./pcdd-panel.component.css']
})
export class PcddPanelComponent implements OnInit {

  // 默认类型下标
  public default_play_type_index: number = 0;
  //  玩法菜单
  public play_menu: Array<any>;
  // 当前玩法id
  public current_play_id: number;
  // 当前玩法说明
  public current_play_info: any;
  // 样式
  public bar_style: any = { color: '#fff' };

  constructor(
    public betInfoService: BetInfoService,
    public api: ApiService
  ) {
    this.api.get_request_pcdd_game_config().subscribe(data => {
      let note: string;

      if (data) {
        GameConfig.pcdd_game_config = data['credit_game_config'];
        this.play_menu = data['credit_game_config'];
        this.current_play_id = data['credit_game_config'][0]['id'];
        note = data['credit_game_config'][0]['bonus_note'];

        this.current_play_info = note.replace(/\<br>/g, ' ');
        this.betInfoService.set_play_info_handler(data['credit_game_config'][0]);
      }
    });
  }

  ngOnInit() {
  }

  /**
   * 切换玩法类型
   *
   * @param {*} e
   * @memberof PcddPanelComponent
   */
  public switch_play_menu_handler(e: any) {
    this.default_play_type_index = e;
    this.current_play_id = this.play_menu[e]['id'];
    this.betInfoService.set_play_info_handler(this.play_menu[e]);
  }

}
